import React, { Component } from "react";
import ModalIMG from "../layout/ModalIMG";
import { dataInfoografias } from "../data/dataInfografias";

export default class Infografias extends Component {
  render() {
    // Agrupa la data por el campo "grupo"
    const groupedData = dataInfoografias.reduce((acc, item) => {
      if (!acc[item.grupo]) {
        acc[item.grupo] = [];
      }
      acc[item.grupo].push(item);
      return acc;
    }, {});

    // Ordena los grupos en orden descendente
    const sortedGroups = Object.keys(groupedData).sort((a, b) => b - a);

    return (
      <>
        <h1 className="text-center mb-4 mt-3">INFOGRAFÍAS</h1>

        {/* CSS del grid */}
        <style>
          {`
            .Galeria__responsive {
              display: grid;
              grid-template-columns: repeat(3, 1fr);
              gap: 16px; 
              margin-bottom: 60px;
            }

            .Galeria__responsive-item {
              width: 100%;
            }

            @media (max-width: 992px) {
              .Galeria__responsive {
                grid-template-columns: repeat(2, 1fr);
              }
            }

            @media (max-width: 576px) {
              .Galeria__responsive {
                grid-template-columns: 1fr;
              }
            }
          `}
        </style>

        {/* Renderizado por grupos */}
        {sortedGroups.map((grupo) => (
          <div key={grupo} className="Galeria__responsive">
            {groupedData[grupo].map((img) => (
              <div key={img.id} className="Galeria__responsive-item">
                <a
                  href="/#"
                  rel="noreferrer"
                  data-bs-toggle="modal"
                  data-bs-target={"#Modal" + img.id}
                >
                  <img
                    src={img.imgURL}
                    alt={img.alt}
                    className="img-fluid rounded"
                  />
                </a>

                <ModalIMG
                  idModal={"Modal" + img.id}
                  altIMG={img.alt}
                  linkIMG={img.imgURL}
                />
              </div>
            ))}
          </div>
        ))}
      </>
    );
  }
}
